import React from "react";
import { Menu, MenuItem } from "@outpave/ds";

interface Action {
  label: string;
  onClick: () => void;
  shouldNotShow?: boolean;
  disabled?: boolean;
  danger?: boolean;
}

interface TableActionMenuProps {
  /** Override the default DOM id. Required when multiple TableActionMenus may
   * mount on the same page (e.g. one per Table instance) to keep ids unique. */
  id?: string;
  anchorEl: null | HTMLElement;
  menuItemDetails: Action[];
  handleCloseTableActions: () => void;
}

const TableActionMenu: React.FC<TableActionMenuProps> = ({
  id = "action-menu",
  anchorEl,
  menuItemDetails,
  handleCloseTableActions,
}) => (
  <Menu
    id={id}
    anchorEl={anchorEl}
    keepMounted
    open={Boolean(anchorEl)}
    onClose={handleCloseTableActions}
  >
    {menuItemDetails
      .filter((menuItem) => !menuItem.shouldNotShow)
      .map((menuItem) => (
        <MenuItem
          key={menuItem.label}
          disabled={menuItem.disabled}
          danger={menuItem.danger}
          onClick={menuItem.onClick}
        >
          {menuItem.label}
        </MenuItem>
      ))}
  </Menu>
);

export default TableActionMenu;
